import { Isvg } from './svg.interface';

const CheckboxChecked = ({ width = 24, height = 24, color = '#212B36' }: Isvg) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 0H3C1.34315 0 0 1.34315 0 3V15C0 16.6569 1.34315 18 3 18H15C16.6569 18 18 16.6569 18 15V3C18 1.34315 16.6569 0 15 0Z"
      fill="#006aff"
    />
    <path
      d="M13.3 6.60992L8.72995 12.6099C8.54116 12.8552 8.24945 12.9992 7.93995 12.9999C7.63217 13.0016 7.34077 12.8614 7.14995 12.6199L4.70995 9.50992C4.49023 9.22768 4.43778 8.84966 4.57235 8.51826C4.70691 8.18685 5.00806 7.95242 5.36235 7.90326C5.71663 7.85409 6.07023 7.99768 6.28995 8.27992L7.91995 10.3599L11.7 5.35992C11.9179 5.0741 12.2717 4.92627 12.6282 4.9721C12.9847 5.01792 13.2897 5.25045 13.4282 5.5821C13.5668 5.91374 13.5179 6.2941 13.3 6.57992V6.60992Z"
      fill="#EDEDEE"
    />
  </svg>
);

export default CheckboxChecked;
